import capReducer from './components/pages/Cap/reducer';
import CapLanguageProviderReducer from '@capillarytech/cap-ui-library/CapLanguageProvider/reducer';
import CapCollapsibleLeftNavigationReducer from '@capillarytech/cap-ui-library/CapCollapsibleLeftNavigation/reducer';
import newLoginReducer from './components/pages/NewLogin/reducer';

export const initialReducer = {
  language: CapLanguageProviderReducer,
  intouchCap: capReducer,
  navigationConfig: CapCollapsibleLeftNavigationReducer,
  newLogin: newLoginReducer,
};